import { PageLink } from "../../../_start/layout/core";

export const quotationManagementSubmenu: Array<PageLink> = [
	{
		title: "Quotations",
		path: "/quotation-management/quotations",
		isActive: true,
	},
];
